import { useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosArrowRoundBack } from "react-icons/io";
import CommonFooter from "../../CommonFooter/CommonFooter";
import CommonButton from "../../ui/CommonButton/CommonButton";
import InputField from "../../ui/InputField/InputField";
import classes from "./IntroductionB.module.css";
import { useAccreditation } from "../../../hooks/useAccreditation";

const IntroductionB = () => {
  const { labId } = useParams();
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false);

  const { formData, setFormData, loading, hydrated, fetching, editable, setEditable, handleDone } =
    useAccreditation({
      labId,
      section: "IntroductionB",
      name: "SADCAS F134-B",
      auditorId: user._id,
      isAssessor: user.role === "ASSESSOR",
      isEditing,
      token,
    });

  const handleFieldChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const questionSets = [
    {
      questions1: [
        { field: "assessor", label: "Assessor/s", placeholder: "Enter username" },
        { field: "observers", label: "Observers", placeholder: "Enter Observers" },
        { field: "areaOfOperation", label: "Area/Field of operation", placeholder: "Enter area" },
        { field: "labRepresentative", label: "Laboratory representative", placeholder: "Enter representative" },
      ],
      render: (onFieldChange, values) => (
        <div className="row mb-5">
          {questionSets[0].questions1.map((q) => (
            <div className="col-6 mb-3" key={q.field}>
              <InputField
                labelText={q.label}
                placeholder={q.placeholder}
                value={values[q.field] || ""}
                onChange={(e) => onFieldChange(q.field, e.target.value)}
                disabled={!editable}
              />
            </div>
          ))}
        </div>
      ),
    },
  ];

  if (!hydrated || fetching) {
    return <div className={classes.loading}>Loading...</div>;
  }

  return (
    <div className={`${classes.wrapper} ${!editable ? classes.fromParams : ""}`}>
      <div className="d-flex justify-content-between align-items-center">
        <div
          className="d-flex align-items-center gap-2 mb-4"
          onClick={() => navigate(-1)}
          role="button"
        >
          <IoIosArrowRoundBack size={35} />
          <h2 className="m-0">Introduction</h2>
        </div>
        {user.role === "ASSESSOR" && !editable && (
          <CommonButton
            className={classes.editButton}
            onClick={() => {
              setIsEditing(true);
              setEditable(true);
            }}
            title="Edit"
          />
        )}
      </div>

      {!editable ? (
        <div className={classes.infoText}>
          ✅ Your SADCAS B - Introduction has been submitted.
        </div>
      ) : (
        questionSets[0].render(handleFieldChange, formData)
      )}

      {editable && (
        <CommonFooter
          handlePrevious={() => navigate(-1)}
          handleNext={() => {}}
          handleDone={handleDone}
          cancelText="Cancel"
          handleCancel={() => setEditable(false)}
          currentSet={0}
          questionSets={questionSets}
          doneText={loading ? "Submitting..." : "Update"}
          disabled={loading}
        />
      )}
    </div>
  );
};

export default IntroductionB;